<script>
import store from '../../store/index.js';
import {reduce} from 'lodash';
export default {
    data() {
		return { 
            list: store.carSeries.series.list,
            seriesEl: null,
            recSeriesArr: [],
            shuffleArr:[]
        }
    },
    computed: {
        recommendSeriesFixedItems() {
            return store.recommendSeriesFixedItems;
        },
        testId() {
            return store.testId
        },
        seriesId() {
            return store.form.series.id
        },
        cityId() {
            return store.form.position.cityId
        }
    },
    created() {
        this.arrayShuffle();
    },
    mounted() {
    },
    methods: {
        changeRecommendSeries(item) {
            item.checked = !item.checked
            console.log(this.recommendSeriesFixedItems)
        },
        arrayShuffle() {
            let arr=[0,1,2,3,4];
            for (var i = arr.length-1; i>=0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = arr[i];
                arr[i] = arr[j];
                arr[j] = temp;
            }
            this.shuffleArr = arr;
        },
        changeStatus(recArr) {
            var _this = this;
            var arr = [];
            arr.push(recArr[_this.shuffleArr[0]], recArr[_this.shuffleArr[1]], recArr[_this.shuffleArr[2]]);
            arr.map((item, index) => {
                // if (index == 0) {
                //     item.checked = true;
                // } else {
                //     item.checked = false;
                // }
                item.checked = false;
            })
            // recArr[_this.shuffleArr[0]].checked = false;
            recArr[_this.shuffleArr[3]].checked = false;
            recArr[_this.shuffleArr[4]].checked = false;
            this.recSeriesArr = arr;
        }
    },
    watch: {
        recommendSeriesFixedItems: function(val) {
            if (val.length == 5) {
                this.changeStatus(val)
            }
        },
        seriesId:  function() {
            this.arrayShuffle();
        },
        cityId: function() {
            this.arrayShuffle();
        }
    }
}
</script>
<template>
<div class="recommend-series">
    <h2 class="title"><span>95%</span> 的用户同时勾选并咨询了以下车系</h2>
    <ul class="list-wrap j-recommend">
        <li class="item-list j-recommend-item" @click="changeRecommendSeries(item)" :class="{checked: item.checked}" v-for="(item) in recSeriesArr" :key="item.id">
            <i class="checkbox"></i>
            <h3>{{item.seriesName}}</h3>
            <img :src="item.seriesImg" alt="">
            {{item.checked}}
        </li>
    </ul>
</div>
</template>
<style lang="stylus" scoped>
.recommend-series
    margin-top .6rem
    display none
    .title
        color #333
        font-size .7rem
        line-height 1.7rem
        height 1.7rem
        margin-bottom .8rem
        // margin-left -1.173rem
        background linear-gradient(270deg, rgba(238, 238, 238, 0) 0%, rgba(216, 216, 216, 0.56) 100%)
        span
            font-size .8rem
            line-height .9rem
    .list-wrap
        display flex
        align-content center
        justify-content space-between
        margin-bottom: -.5rem;
        li
            position relative
            text-align center
            width 33.333333%
            i
                position absolute
                left 0 
                top 0
                width .9rem
                height .9rem
                background url("../../../assets/unchosen_icon.png") no-repeat center center;
                background-size cover
                border-radius: 50%;
            h3
                font-size .7rem
                line-height .9rem
                color #333
                margin-left 1.1rem
                text-align left
                font-weight normal
                margin-bottom .5rem
            img 
                width 4.85rem
                height 3.5rem
            &.checked
                i
                    background url("../../../assets/chosen_icon.png") no-repeat center center;
                    background-size cover

</style>